module.exports = __webpack_public_path__ + "theme2.css.liquid";


//////////////////
// WEBPACK FOOTER
// ./resources/styles/theme.scss
// module id = 402
// module chunks = 0